import * as React from "react";
import { mergeProps, useButton } from "react-aria";
import { OverlayArrow, Tooltip as AriaTooltip, TooltipTrigger } from "react-aria-components";
import { cx } from "../../helpers/utils/cx";
const DEFAULT_OFFSET = 10;
const DEFAULT_DELAY = 25;
const DEFAULT_PLACEMENT = "top";
const TriggerWrap = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children
  } = _ref;
  const {
    buttonProps
  } = useButton(children.props, ref);

  // remove react-aria events that close tooltip on click or button press
  delete buttonProps.onPointerDown;
  delete buttonProps.onMouseDown;
  delete buttonProps.onClick;
  delete buttonProps.onKeyDown;
  return /*#__PURE__*/React.cloneElement(children, mergeProps(buttonProps, children.props, {
    ref
  }));
});
const arrowPositions = {
  left: "rotate-90 -ml-[3px]",
  right: "-rotate-90 -mr-[3px]",
  top: "rotate-180",
  bottom: "",
  center: ""
};
const arrowPositionAdjustments = {
  left: "!top-1/2",
  right: "!top-1/2",
  top: "!left-1/2",
  bottom: "!left-1/2",
  center: ""
};
function getArrowAdjustmentClassname(props) {
  return cx(arrowPositionAdjustments[props.placement || DEFAULT_PLACEMENT]);
}
export function Tooltip(_ref2) {
  let {
    isOpen,
    onOpenChange,
    children,
    content,
    delay = DEFAULT_DELAY,
    placement = DEFAULT_PLACEMENT,
    offset = DEFAULT_OFFSET,
    boundaryElement
  } = _ref2;
  const triggerRef = React.useRef(null);
  const dialog = triggerRef.current?.closest("dialog");
  return content.length ? /*#__PURE__*/React.createElement(TooltipTrigger, {
    isOpen: isOpen,
    onOpenChange: onOpenChange,
    delay: delay
  }, /*#__PURE__*/React.createElement(TriggerWrap, {
    ref: triggerRef
  }, children), /*#__PURE__*/React.createElement(AriaTooltip, {
    placement: placement,
    offset: offset,
    className: cx("max-w-[280px] w-max bg-neutral-primary py-2 px-3 rounded text-primary-inverted ease-out", "bolt-font-body-s-regular break-words text-left"),
    UNSTABLE_portalContainer: boundaryElement || dialog || undefined
  }, /*#__PURE__*/React.createElement(OverlayArrow, {
    className: dialog ? getArrowAdjustmentClassname : undefined
  }, props => /*#__PURE__*/React.createElement("div", {
    className: cx("w-0 h-0 border-solid border-t-0 border-b-[6px] border-x-[6px] border-b-[var(--color-bg-neutral-primary)] border-x-transparent", arrowPositions[props.placement || DEFAULT_PLACEMENT])
  })), content)) : children;
}